import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import _ from 'underscore';
import { withStyles } from '@material-ui/core';
import { Button, TextField, CircularProgress, Typography } from '@material-ui/core';
import { Portlet, PortletHeader, PortletLabel, PortletContent, PortletFooter } from 'components';

import api from '../../../../api';
import styles from './styles';
import schema from './schema';

class AccountResetPassword extends Component {
  state = {
    values: {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    userEmail: '',
    touched: {
      currentPassword: false,
      newPassword: false,
      confirmNewPassword: false,
    },
    errors: {
      currentPassword: null,
      newPassword: null,
      confirmNewPassword: null,
    },
    loading: true,
    saving: false,
    isValid: false,
    errorMessage: '',
    successMessage: '',
  };

  async componentDidMount() {
    try {
      const response = await api.getCurrentInfo();
      this.setState({
        userEmail: response.data.email,
        loading: false,
      });
    } catch (error) {
      console.error('Error fetching user data:', error);
      this.setState({ loading: false, errorMessage: 'Failed to load user info' });
    }
  }

  validateForm = _.debounce(() => {
    const { values } = this.state;

    let errors = validate(values, schema) || {};
    if (values.newPassword !== values.confirmNewPassword) {
      errors.confirmNewPassword = ['Passwords do not match'];
    }

    this.setState({
      errors,
      isValid: Object.keys(errors).length === 0,
    });
  }, 300);

  handleFieldChange = (field, value) => {
    this.setState(
      prevState => ({
        values: {
          ...prevState.values,
          [field]: value,
        },
        touched: {
          ...prevState.touched,
          [field]: true,
        },
        errorMessage: '',
        successMessage: '',
      }),
      this.validateForm
    );
  };

  handleResetPassword = async () => {
    try {
      this.setState({ saving: true });

      const response = await api.updatePassword({
        password: this.state.values.currentPassword,
        newPassword: this.state.values.newPassword,
        email: this.state.userEmail,
      });

      console.log("✅ Réponse reçue :", response);
      this.setState({
        saving: false,
        errorMessage: '',
        successMessage: "Mot de passe mis à jour avec succès !",
        values: {
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        },
        touched: {
          currentPassword: false,
          newPassword: false,
          confirmNewPassword: false,
        },
      });

    } catch (error) {
      console.error("❌ Erreur reçue dans handleResetPassword :", error.response ? error.response.data : error);

      this.setState({
        saving: false,
        errorMessage: error.response?.data?.message || "❌ Une erreur inconnue est survenue.",
      });
    }
  };

  render() {
    const { classes, className, ...rest } = this.props;
    const { values, touched, errors, isValid, loading, saving, errorMessage, successMessage } = this.state;

    const rootClassName = classNames(classes.root, className);

    if (loading) return <CircularProgress className={classes.progress} />;

    return (
      <Portlet {...rest} className={rootClassName}>
        <PortletHeader>
          <PortletLabel title="Reset Password" />
        </PortletHeader>
        <PortletContent noPadding>
          {errorMessage && <Typography color="error" align="center">{errorMessage}</Typography>}
          {successMessage && <Typography color="primary" align="center">{successMessage}</Typography>}

          <form autoComplete="off" noValidate>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Current Password"
                margin="dense"
                required
                value={values.currentPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={touched.currentPassword && errors.currentPassword ? errors.currentPassword[0] : ''}
                onChange={event => this.handleFieldChange('currentPassword', event.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="New Password"
                margin="dense"
                required
                value={values.newPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={touched.newPassword && errors.newPassword ? errors.newPassword[0] : ''}
                onChange={event => this.handleFieldChange('newPassword', event.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Confirm New Password"
                margin="dense"
                required
                value={values.confirmNewPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={touched.confirmNewPassword && errors.confirmNewPassword ? errors.confirmNewPassword[0] : ''}
                onChange={event => this.handleFieldChange('confirmNewPassword', event.target.value)}
              />
            </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
          {saving ? (
            <CircularProgress className={classes.progress} />
          ) : (
            <Button color="primary" variant="contained" onClick={this.handleResetPassword} disabled={!isValid}>
              Change Password
            </Button>
          )}
        </PortletFooter>
      </Portlet>
    );
  }
}

AccountResetPassword.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountResetPassword);
